import axios from "axios";
import { toasterError } from "../Components/toaster";


export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ---------- Request Interceptor ---------- */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* ---------- Response Interceptor ---------- */
axiosInstance.interceptors.response.use(
  (response) => {

    return response?.data ?? response;
  },

  (error) => {
    let message;
    if (error?.response?.data) {
      error.status = error?.response?.status;
      error.message =error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.metadata?.message;
    }
    const detail = error?.response?.data?.detail;
    if (typeof detail === "string" && (detail.includes("Authentication credentials were not provided") || detail.includes("Token Expired"))) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
      error.message = "token Expired";
      toasterError("Token Expired")
    }

    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 400:
        toasterError(error?.response?.data?.message || error?.response?.data?.error);
        message = error?.response?.data?.message|| 
          error?.response?.data?.error || error?.response?.message || "Oops! Please enter Valid Inputs";
        break;
      case 401:
        message = error.message || "Unauthorized error";
        localStorage.clear();
        sessionStorage.clear();
        if (error?.message?.includes("token Expired") || error?.message?.includes("Invalid token")) {
          // toasterError("Token Expired");
          window.location.href = "/login";
        }
        else {
          // toasterError(error?.message);
          console.log("unAuthorized", error?.message);
        }
        // error.message = "token Expired";
        break;
      case 404:
        toasterError(error.message);
        message = "Sorry! the data you are looking for could not be found";
        break;
      case 403:
        message = "Sorry! Please login again";
        localStorage.clear();
        sessionStorage.clear();
        window.location = "/login";
        break;
      case 413:
        message = error?.message || "File Is Too Large";
        break;
      default:
        message = error?.message || error;
    }

    return Promise.reject({ message, status: error?.status });
  }
);

/* ---------- API Client ---------- */
class APIClient {
  get(url, config) {
    return axiosInstance.get(url, config);
  }


  // POST
  create(url, data, config) {
    return axiosInstance.post(url, data, config);
  }

  // PATCH
  update(url, data, config) {
    return axiosInstance.patch(url, data, config);
  }

  // PUT
  put(url, data, config) {
    return axiosInstance.put(url, data, config);
  }

  // DELETE
  delete(url, config) {
    return axiosInstance.delete(url, config);
  }
}

const apiClient = new APIClient();
export default apiClient;
export { APIClient };

